import { render } from "./authority.vue?vue&type=template&id=02a91be2&scoped=true"
import script from "./authority.vue?vue&type=script&lang=js"
export * from "./authority.vue?vue&type=script&lang=js"

import "./authority.vue?vue&type=style&index=0&id=02a91be2&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a91be2"]])

export default __exports__